import React, { Component } from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

class MyLoader extends Component {
    state = { show: false, text: 'Ladataan...' }

    componentDidMount() {
        this.delayTimer = setTimeout(() => {
            this.setState({ show: true })
        }, 200)

    }

    componentWillUnmount() {
        clearTimeout(this.delayTimer)
    }

    render() {
        if (!this.state.show) return null

        return (
            <Dimmer active>
                <Loader content={this.state.text} />
            </Dimmer>
        )
    }
}

export default MyLoader



// WEBPACK FOOTER //
// ./src/Shared/Loader.js